import styled from 'styled-components';
import { useTranslation } from 'next-i18next';
import {
  SearchContext,
  SearchContextInterface
} from '../../../search-new/context/SearchContext';
import { useContext } from 'react';
import { SearchFiltersActionTypes } from '../../../../reducers/search-filters/actions';
import { SearchFiltersTypes } from '../../../../reducers/search-filters/reducer';
import { updateQuery } from '../../../../helpers/common';
import { useRouter } from 'next/router';

const FiltersAlert = () => {
  const { t } = useTranslation('common');

  const { searchFiltersDispatch, appliedFiltersCount } = useContext(
    SearchContext
  ) as SearchContextInterface;
  const router = useRouter();

  const handleResetFilters = () => {
    searchFiltersDispatch({
      type: SearchFiltersActionTypes.RESET
    });

    searchFiltersDispatch({
      type: SearchFiltersActionTypes.UPDATE_FILTERS_WITH_SINGLE_VALUE,
      payload: {
        name: SearchFiltersTypes.CATEGORY,
        value: 'property'
      }
    });

    const filterKeys = Object.values(SearchFiltersTypes);
    const keysToRemove = Object.keys(router.query).filter(key =>
      filterKeys.includes(key as SearchFiltersTypes)
    );
    updateQuery(router, undefined, keysToRemove);
  };

  return appliedFiltersCount > 0 ? (
    <Container>
      <span>* {t('prices_shown_reflect_filters')}</span>
      <button onClick={handleResetFilters}>{t('clear')}</button>
    </Container>
  ) : null;
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  color: #015c9a;
  font-family: materialRegular;
  font-size: 14px;
  line-height: 150%;
  width: 100%;
  justify-content: space-between;

  button {
    background: none;
    border: none;
    color: #015c9a;
    font-family: materialMedium;
    font-size: 14px;
    line-height: 150%;
    cursor: pointer;
    text-decoration: underline;
  }

  @media screen and (max-width: 768px) {
    font-family: materialLight;
    font-size: 12px;
    justify-content: space-evenly;
    margin-top: 8px;
    button {
      font-family: materialRegular;
      font-size: 12px;
    }
  }
`;

export default FiltersAlert;
